// $(document).ready(function () {
//   var goToTop = $('#back-to-top');
//   goToTop.hide();
//   $(window).scroll(function () {
//     if ($(window).scrollTop() > 100) goToTop.fadeIn();
//     else goToTop.fadeOut();
//   });
//   goToTop.on("click", function () {
//     $('body,html').animate({
//       scrollTop: 0
//     }, 1000);
//     return false;
//   });
//   repositionArrow();
//   $(window).resize(function () {
//     repositionArrow();
//   });
// });

// function repositionArrow() {
//   if ($(window).width() > 1920) {
//     varRight = ($(window).width() - 1920) / 2 + 15
//     $('#back-to-top a').css('right', varRight);
//   }
// }

$(function () {
  var controller = new ScrollMagic.Controller();

  var duration = Math.floor((window.innerHeight / 3) * 2);
  var offset = 100;

  if (duration + offset > (document.body.clientHeight - window.innerHeight)) {
    var diff = (duration + offset) - (document.body.clientHeight - window.innerHeight);
    duration -= diff * 2;
  }

  new ScrollMagic.Scene({
      duration: duration,
      offset: offset,
    })
    .on('start', function (event) {
      if (event.scrollDirection === 'FORWARD') {
        $('#back-to-top').css('display', 'block');
      } else if (event.scrollDirection === 'REVERSE') {
        $('#back-to-top').css('display', 'none');
      }
    })
    .on('progress', function (event) {
      $('#back-to-top').css('opacity', event.progress);
    })
    .addTo(controller);
})